/* eslint-disable import/prefer-default-export */
import styled from '@bd/bdui-styles/emotion';
import { get } from 'lodash';

import icons from '../components/IconsList';
import { colors } from '../styles';


export const H2Underdog = styled('h2')`
  position: relative;
  margin: 0 0 38px;
  padding: 0 0 20px;
  @media(min-width: 992px) {
    margin: 0 0 48px;
    padding: 0 0 30px;
  }
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 75px;
    height: 1px;
    background-color: #ADADAD;
    @media(min-width: 992px) {
      width: 150px;
    }
  }
  &::before {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 75px;
    height: 1px;
    background-color: #ADADAD;
    @media(min-width: 992px) {
      width: 150px;
    }
  }
`;

export const H2UnderdogSection = styled('h2')`
  position: relative;
  margin: 0 0 38px;
  padding: 0 0 20px;
  @media(min-width: 992px) {
    margin: 0 0 48px;
    padding: 0 0 30px;
  }
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 75px;
    height: 1px;
    background-color: #ADADAD;
    @media(min-width: 992px) {
      left: 50%;
      transform: translateX(-50%);
      width: 150px;
    }
  }
  &::before {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 75px;
    height: 1px;
    background-color: #ADADAD;
    @media(min-width: 992px) {
      left: 50%;
      transform: translateX(-50%);
      width: 150px;
    }
  }
`;

export const BtnAnimationSheen = styled('span')`
  position: relative;
  overflow: hidden;
  &::after {
    content: '';
     position: absolute;
     top: -50%;
     right: 10%;
     bottom: -50%;
     left: -50%;
     background: linear-gradient(to bottom, rgba(214, 155, 41, 0), rgba(140, 205, 235, 0.4) 50%, rgba(214, 155, 41, 0.65));
     transform: rotateZ(60deg) translate(-5em, 7.5em);
  }
  &:hover {
    color: #FFFFFF;
  }
  &:hover::after, &:focus::after {
    animation: sheen 1s forwards;
    right: -88%;
  }
  @keyframes sheen {
    100% {
      transform: rotateZ(60deg) translate(1em, -9em);
    }
  }
`;

export const UnderdogLeft = styled('div')`
  position: relative;
  margin: 0 0 20px;
  padding: 0 0 26px;
  @media(min-width: 992px) {
    margin: 0 0 30px;
    padding: 0 0 37px;
  }
  &::after, &::before {
    content: '';
    position: absolute;
    left: 0;
    width: 41px;
    height: 1px;
    background-color: #ADADAD;
    @media(min-width: 992px) {
      width: 75px;
    }
  }
  &::after {
    bottom: 0;
  }
  &::before {
    bottom: 6px;
    @media(min-width: 92px) {
      bottom: 7px;
    }
  }
`;

export const UnderdogCenter = styled('div')`
  position: relative;
  margin: 0 0 20px;
  padding: 0 0 26px;
  @media(min-width: 992px) {
    margin: 0 0 37px;
    padding: 0 0 37px;
  }
  &::after {
    content: '';
    position: absolute;
    width: 75px;
    height: 4px;
    background-color: ${colors.color1};
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    @media(min-width: 992px) {
      width: 75px;
      height: 3px;
    }
  }
`;

export const UnderdogLeftAlt = styled('div')`
  position: relative;
  margin: 0 0 26px;
  padding: 0 0 26px;
  @media(min-width: 992px) {
    margin: 0 0 37px;
    padding: 0 0 37px;
  }
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 50px;
    height: 2px;
    background-color: ${colors.color1};
    bottom: 0;
    @media(min-width: 992px) {
      width: 75px;
      height: 3px;
    }
  }
`;

export const ButtonDefault = styled('div')`
  position: relative;
  transition: padding-left 1s ease;
  height: 38px;
  width: auto;
  display: flex;
  @media(min-width: 992px) {
    height: 53px;
  }
  &::after {
    content: '';
    background-image: url(${get(icons, 'arrowRight')});
    width: 38px;
    height: 15px;
    background-position: center center;
    display: inline-flex;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    transition: all .3s ease-out;
  }
  &:hover {
    &::after {
      right: 15px;
    }
  }
  a {
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  span {
    font-weight: 700;
    font-size: 13px;
    color: ${colors.text};
    letter-spacing: 0;
    width: calc(100% - 50px);
    text-align: center;
    @media(min-width: 992px) {
      font-size: 17px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/helpers/UIElements.js